module.exports = __webpack_public_path__ + "static/media/raumplan.1c569f56.png";